import { memo } from 'react'
import { shallowEqual } from 'react-redux'

import { AddressBlock } from './components/addressBlock/AddressBlock'
import { CommonBlock } from './components/commonBlock/CommonBlock'
import { HierarchyBlock } from './components/hierarchyBlock/HierarchyBlock'
import { IPartnerBasicInfoProps } from './models'

import styles from './PartnerBasicInfo.module.scss'

export const PartnerBasicInfo = memo<IPartnerBasicInfoProps>((props) => {
  return (
    <div className={styles.container}>
      <HierarchyBlock {...props} />
      <AddressBlock {...props} />
      <CommonBlock {...props} />
    </div>
  )
}, shallowEqual)

PartnerBasicInfo.displayName = 'PartnerBasicInfo'
